export class RecommendAgent {
  ID: number;
  ReceiverId: number;
  StatusId: number;
  SenderId: number;
  HowDoYouKnowId: number;
  Text: string;
  IsDeleted: boolean;
  IsVisible: boolean;
  SenderName: string;
  Status: string;
  SendDate: Date;
  DateCreated: string;
}
